import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { colorContrast } from '@ep-om/utils/styleUtils';

@Component({
  selector: 'om-button',
  templateUrl: './om-button.component.html',
  styleUrls: ['./om-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OmButtonComponent {
  @Input() type: string = 'button';

  @Input() color: string = 'primary';
  @Input() customColor: string;
  @Input() size: string = 'default';
  @Input() expand = false;
  @Input() iconOnly = false;

  @Input() isLoading = false;
  @Input() disabled = false;

  @Input() svgIcon: string;
  @Input() antIcon: string;

  constructor() { }

  get _buttonStyle() {
    let style;
    if (this.customColor) style = { 'background': this.customColor, 'color': colorContrast(this.customColor) };
    return style;
  }

}
